import { Text as ChakraText, forwardRef, TextProps } from '@chakra-ui/react';

/**
 Text is the used to render text and paragraphs within an interface.
 */
export const Text = forwardRef((props: TextProps, ref) => {
  const { children, ...otherProps } = props;
  return (
    <ChakraText ref={ref} {...otherProps}>
      {children}
    </ChakraText>
  );
});
